/** Teeman yhteiset valikkotoiminnot. */
(function () {
  'use strict';

  var hamburger = document.querySelector('button.hamburger');
  var nav = document.getElementById('nav');
  if (!hamburger || !nav) return;

  var mobile = window.matchMedia('(max-width: 1032px)');
  var navIcon = document.getElementById('nav-icon');
  var contacts = document.querySelector('.header-yhteystiedot');

  // Piilotetut valikot eivät jää näppäimistön tai ruudunlukijan käyttöön.
  function asetaValikko(auki) {
    document.body.classList.toggle('navi-open', auki);
    hamburger.classList.toggle('open', auki);
    if (navIcon) navIcon.classList.toggle('open', auki);
    hamburger.setAttribute('aria-expanded', String(auki));
    nav.setAttribute('aria-hidden', String(mobile.matches && !auki));
    if (contacts) contacts.setAttribute('aria-hidden', String(mobile.matches && !auki));
  }

  nav.querySelectorAll('.menu-item-has-children').forEach(function (item, index) {
    var submenu = item.querySelector(':scope > .sub-menu');
    var link = item.querySelector(':scope > a');
    if (!submenu || !link) return;
    var button = document.createElement('button');
    submenu.id = submenu.id || 'alavalikko-' + index;
    button.type = 'button';
    button.className = 'alavalikko-painike';
    button.setAttribute('aria-label', link.textContent.trim() + ': alavalikko');
    button.setAttribute('aria-controls', submenu.id);
    button.setAttribute('aria-expanded', 'false');
    link.after(button);
    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') !== 'true';
      item.classList.toggle('alavalikko-auki', open);
      button.setAttribute('aria-expanded', String(open));
    });
  });

  hamburger.addEventListener('click', function () {
    asetaValikko(hamburger.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && hamburger.getAttribute('aria-expanded') === 'true') {
      asetaValikko(false);
      hamburger.focus();
    }
  });

  mobile.addEventListener('change', function () { asetaValikko(false); });
  asetaValikko(false);
})();
